import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { mockWaitlistSubmit } from '../mock';
import { toast } from 'sonner';
import { Loader2, ArrowRight } from 'lucide-react';

export const CTA = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !name) {
      toast.error('Please fill in all fields');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);
    
    try {
      const result = await mockWaitlistSubmit(email, name);
      if (result.success) {
        toast.success(result.message);
        setEmail('');
        setName('');
      }
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="cta" className="py-16 md:py-32 bg-[#0A0E14] relative overflow-hidden">
      <div className="absolute inset-0 pro-grid opacity-30"></div>
      <div className="ambient-glow absolute top-0 left-0 w-[500px] md:w-[600px] h-[500px] md:h-[600px] bg-green-500"></div>
      <div className="ambient-glow absolute bottom-0 right-0 w-[500px] md:w-[600px] h-[500px] md:h-[600px] bg-emerald-500" style={{ animationDelay: '5s' }}></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-4">
            Start Building <span className="text-green-400">Today</span>
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-400 px-4">
            Join developers across India who trust MBhost for their infrastructure
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="max-w-2xl mx-auto">
          <div className="glass-card p-6 md:p-10 rounded-xl md:rounded-2xl">
            <div className="space-y-4 md:space-y-5 mb-6 md:mb-8">
              <Input
                type="text"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="h-12 md:h-14 bg-white/5 border-white/10 text-white placeholder:text-gray-500 focus:border-green-500/50 transition-all text-sm md:text-base"
                disabled={loading}
              />
              
              <Input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-12 md:h-14 bg-white/5 border-white/10 text-white placeholder:text-gray-500 focus:border-green-500/50 transition-all text-sm md:text-base"
                disabled={loading}
              />
            </div>
            
            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 md:h-14 bg-green-500 hover:bg-green-400 text-black font-semibold transition-all duration-200 shadow-lg shadow-green-500/20 hover:shadow-green-500/30 text-sm md:text-base"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 animate-spin" size={18} />
                  Processing...
                </>
              ) : (
                <>
                  Get Started Free
                  <ArrowRight className="ml-2" size={18} />
                </>
              )}
            </Button>
            
            <p className="text-center text-gray-500 text-[10px] md:text-xs mt-3 md:mt-4">
              No credit card required • Cancel anytime
            </p>
          </div>
        </form>
      </div>
    </section>
  );
};